module.exports = __webpack_public_path__ + "img/Bear01.bb2af7df.jpg";